<template>
  <div id="footer">
    <div class="linkArea">
      <p class="edition">
        版本號：{{ version }}
      </p>
    </div>
    <div class="copyRight">
      {{ $t('General.Copyright1') }}
      <br>
      {{ $t('General.Copyright2', { thisYear: new Date().getFullYear() }) }}
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      version: `${process.env.VUE_APP_VERSION}.${process.env.VUE_APP_VERSION_DATE}`// 版號
    }
  },
  mounted () {

  },
  methods: {
    toAnn () {
      window.location.href = `${window.location.origin}/community/systemUpdates.aspx`
    }
  }
}
</script>

<style lang="sass" scoped>
#footer
  min-width: 1140px
  text-align: center
  padding: 15px 35px
  box-sizing: border-box
  .linkArea
    position: relative
    color: $mainColor
    margin: 0 0 10px
    a
      color: $mainColorDark
      cursor: pointer
    .edition
      position: absolute
      top: 0
      right: 0
      color: $subFontColor
      display: inline-block
      font-size: map-get($fontSize,x-small)
  .phone
    font-size: map-get($fontSize,xx-large)
    font-weight: bold
    color: $mainFontColor
    margin: 0 0 10px
    span
      vertical-align: middle
    .tip
      font-size: map-get($fontSize,small)
      font-weight: normal
  .copyRight
    font-size: map-get($fontSize,x-small)
    color: $subFontColor
    margin: 0 0 10px
    line-height: 1.5
</style>
